import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordNormalized,
  RouteRecordRaw,
} from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verificando sesión',
        },
      },
    ],
  },
  // app routes
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    children: [
      {
        path: '',
        name: 'app-root',
        component: () => import('../views/app/firestore/databases.vue'),
        meta: {
          title: 'Databases',
        },
      },
      // {
      //   path: '',
      //   name: 'app-home',
      //   component: () => import('../views/app/firestore/index.vue'),
      //   meta: {
      //     title: 'Colecciones y documentos',
      //   },
      // },
      // {
      //   path: 'docs/:collection',
      //   name: 'app-docs',
      //   component: () => import('../views/app/firestore/docs.vue'),
      //   meta: {
      //     title: 'Documentos',
      //   },
      // },
      // {
      //   path: 'docs/:collection/:doc',
      //   name: 'app-doc',
      //   component: () => import('../views/app/firestore/doc.vue'),
      //   meta: {
      //     title: 'Documento',
      //   },
      // },
      // any path
      {
        path: ':pathMatch(.*)*',
        name: 'app-disambiguation',
        component: () => import('../views/app/disambiguation.vue'),
        meta: {
          title: 'Fireweb',
          requiresAuth: true,
        },
      },
    ],
  },
  // undefined path redirect to /app
  {
    path: '/undefined',
    redirect: '/app',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  // check if requiresAuth and user is not logged in
  if (to.matched.some((record: RouteRecordNormalized) => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token');
    if (!token) {
      // redirect to auth page
      const path = window.location.pathname;
      const query = window.location.search;
      const { VUE_APP_DIGI_USERS_F } = process.env;
      window.location.href = `${VUE_APP_DIGI_USERS_F}/auth/provider?app=fireweb&redirect=${path}${query}`;
    }
  }
  // Set title
  if (to.meta.title) {
    document.title = `${to.meta.title} - Fireweb`;
  }

  // if to in the query string and different from /auth routes
  if (to.query.redirect && !to.path.startsWith('/auth')) {
    // redirect to the to path
    next(to.query.redirect as string);
    return;
  }

  next();
});

export default router;
